module.exports = __webpack_public_path__ + "components/app-promo/static/app-store_badge--black-2c025c33e51d28c5571b8b161b633657.svg";